<app-numeric-keypad (digit)="onDigit($event)">

</app-numeric-keypad>

<div class=e174_470 (click)="onConfirm()">
  <div  class="e174_61">

  </div>
  <span  class="e174_62">
    CONFIRM
  </span>
</div>

<div class="e174_480"
  (click)="doClear()"
>
  <div
    class="e174_64 !bg-gold-500"
    [class.!bg-gold-500]="inputAmount !== ''"
  >

  </div>
  <span  class="e174_65">
    CLEAR
  </span>
</div>

<!-- input field -->
<div class=e175_1744>
  <div  class="e174_59">

  </div>
  <div class=e174_501>
    <span  class="e174_500">PIN</span>
  </div>
  <span  class="e174_513">{{ masked }}</span>
</div>
